import { RouteWrapper, Subtitle } from '@/views/CrehanaLegal/components';

const PersonalDataProtectionPolicyCrehanaATS = () => (
  <RouteWrapper>
    <section>
      <Subtitle>1. INTRODUCCIÓN</Subtitle>
      <p>
        En <strong>Crehana</strong> estamos comprometidos con la protección y el
        respeto de la privacidad y los derechos de los titulares de datos
        personales; por ello, esta política describe cómo recopilamos,
        utilizamos, almacenamos, compartimos y protegemos la información
        personal de nuestros usuarios, clientes, proveedores y terceros, en
        cumplimiento de las normas de protección de datos vigentes en{' '}
        <strong>
          Colombia (Ley 1581 de 2012 y Decreto 1377 de 2013), México (Ley
          Federal de Protección de Datos Personales en Posesión de los
          Particulares), Perú (Ley N.o 29733), Argentina (Ley 25.326) y Chile
          (Ley 19.628),
        </strong>{' '}
        y, en caso de ser necesario para el tratamiento internacional de datos,
        adoptamos las medidas exigidas por otras normativas aplicables en las
        jurisdicciones donde operamos o realizamos transferencias de
        información, incluyendo regulaciones internacionales como el{' '}
        <strong>
          Reglamento General de Protección de Datos (GDPR) de la Unión Europea
        </strong>{' '}
        u otras equivalentes que garanticen un nivel adecuado de protección.
      </p>
      <p>
        Al usar nuestros servicios, acceder a nuestra plataforma tecnológica o
        interactuar con nosotros, usted acepta las condiciones establecidas en
        esta política.
      </p>
      <br />
      <Subtitle>2. DEFINICIONES</Subtitle>
      <p>Para efectos de esta política, se entenderá por: </p>
      <ul>
        <li>
          <strong>Datos personales: </strong> Cualquier información que
          identifique o pueda identificar a una persona natural, de manera
          directa o indirecta.
        </li>
        <li>
          <strong>Datos sensibles: </strong> Aquellos que afectan la intimidad
          del titular o cuyo uso indebido puede generar discriminación, como
          información relacionada con salud, origen étnico, creencias
          religiosas, orientación sexual, entre otros.
        </li>
        <li>
          <strong>Titular de datos personales: </strong> Persona natural cuyos
          datos son objeto de tratamiento.
        </li>
        <li>
          <strong>Tratamiento de datos personales: </strong> Cualquier operación
          o conjunto de operaciones sobre datos personales, tales como
          recolección, almacenamiento, uso, circulación, transmisión o
          supresión.
        </li>
        <li>
          <strong>Responsable del tratamiento: </strong> Persona natural o
          jurídica que decide sobre la finalidad y el uso del tratamiento de
          datos personales.
        </li>
      </ul>
      <p>
        <strong>Encargado del tratamiento: </strong> Persona natural o jurídica
        que trata datos personales por cuenta del responsable.
      </p>
      <br />
      <Subtitle>3. RECOPILACIÓN DE DATOS PERSONALES</Subtitle>
      <p>Crehana podrá recopilar datos personales por las siguientes vías:</p>
      <ul>
        <li>
          <strong>Cuando el usuario se registra en nuestra plataforma</strong> o
          crea una cuenta para acceder a nuestros servicios.
        </li>
        <li>
          <strong>Cuando utiliza nuestros servicios,</strong> incluyendo
          navegación en la plataforma, participación en procesos de formación o
          interacción con herramientas de gestión documental.
        </li>
        <li>
          <strong>Cuando nos proporciona información directamente,</strong>
          por ejemplo, a través de formularios, encuestas, soporte técnico o
          comunicación directa.
        </li>
        <li>
          <strong>
            Automáticamente a través de cookies y tecnologías similares
          </strong>{' '}
          al usar nuestro sitio web y aplicaciones móviles, con el fin de
          mejorar la experiencia del usuario y ofrecer servicios personalizados.
        </li>
      </ul>
      <br />
      <p>
        Los datos que podemos recopilar incluyen, pero no se limitan a: nombre,
        documento de identidad, información de contacto, datos laborales,
        académicos, financieros, así como datos sensibles solo cuando sean
        estrictamente necesarios y con consentimiento explícito.
      </p>
      <br />
      <Subtitle>4. USO DE DATOS PERSONALES</Subtitle>
      <p>
        Crehana utiliza los datos personales para las siguientes finalidades:
      </p>
      <ul>
        <li>
          Procesar solicitudes, pedidos o gestiones realizadas por los usuarios.
        </li>
        <li>
          Proveer y mejorar nuestros servicios tecnológicos y plataformas de
          gestión documental.
        </li>
        <li>
          Personalizar la experiencia en nuestro sitio web y aplicaciones.
        </li>
        <li>
          Enviar comunicaciones relacionadas con nuestros servicios, novedades y
          actualizaciones.
        </li>
        <li>Cumplir con obligaciones legales, contractuales y regulatorias.</li>
        <li>
          Garantizar la seguridad de la información y la prevención de fraudes.
        </li>
      </ul>
      <br />
      <p>
        Cuando actuamos como <strong>encargados del tratamiento</strong> (por
        ejemplo, en procesos de gestión documental para clientes), tratamos los
        datos únicamente siguiendo las instrucciones del responsable y conforme
        a la finalidad definida por este.
      </p>
      <br />
      <Subtitle>5. COMPARTIR DATOS PERSONALES</Subtitle>
      <p>Crehana solo comparte datos personales en los siguientes casos:</p>
      <ul>
        <li>
          <strong>
            Con terceros proveedores de servicios tecnológicos y logísticos,
          </strong>{' '}
          necesarios para la correcta prestación de nuestros servicios (por
          ejemplo, hosting en la nube, soporte técnico).
        </li>
        <li>
          <strong>
            Con autoridades administrativas, judiciales o gubernamentales
          </strong>{' '}
          cuando sea requerido para cumplir con una obligación legal.
        </li>
        <li>
          <strong>Con el consentimiento expreso del titular,</strong> cuando se
          requiera para otras finalidades diferentes a las aquí descritas.
        </li>
      </ul>
      <br />
      <p>
        En caso de transferencias internacionales de datos, garantizamos que se
        cumplan los niveles adecuados de protección exigidos por la normativa
        aplicable.
      </p>
      <br />
      <Subtitle>6. PROTECCIÓN DE DATOS PERSONALES</Subtitle>
      <p>
        Crehana adopta medidas técnicas, organizativas y administrativas para
        proteger los datos personales contra pérdida, acceso no autorizado,
        alteración, divulgación indebida o destrucción. Estas medidas incluyen:
      </p>
      <ul>
        <li>Protocolos de cifrado y transmisión segura de datos.</li>
        <li>Almacenamiento en servidores con altos estándares de seguridad.</li>
        <li>Controles de acceso restringidos a personal autorizado.</li>
        <li>Políticas de gestión de incidentes de seguridad.</li>
      </ul>
      <p>
        Los componentes críticos de la infraestructura tecnológica de{' '}
        <strong>CREHANA</strong> serán sometidos a un proceso sistemático de
        evaluación y gestión de vulnerabilidades, con el fin de determinar y
        asegurar niveles adecuados de protección contra amenazas que puedan
        comprometer la confidencialidad, integridad, disponibilidad y privacidad
        de la información utilizada en los procesos de negocio. Este proceso
        incluye la identificación, análisis y remediación de riesgos para
        garantizar la continuidad y seguridad del servicio ofrecido a los
        clientes.
      </p>
      <br />
      <Subtitle>7. DERECHOS DE LOS TITULARES DE DATOS PERSONALES</Subtitle>
      <p>
        Como titular de los datos personales, usted tiene los siguientes
        derechos:
      </p>
      <ul>
        <li>
          <strong>Acceder</strong> a sus datos personales y conocer el
          tratamiento que se les da.
        </li>
        <li>
          <strong>Rectificar o actualizar</strong> información inexacta,
          incompleta o desactualizada.
        </li>
        <li>
          <strong>Solicitar la supresión</strong> de sus datos personales cuando
          no se requieran para la finalidad para la cual fueron recolectados.
        </li>
        <li>
          <strong>Revocar la autorización</strong> otorgada para el tratamiento
          de sus datos.
        </li>
        <li>
          <strong>Oponerse o restringir el tratamiento,</strong> en los casos
          permitidos por la ley.
        </li>
        <li>
          <strong>Portar sus datos personales</strong> a otro proveedor de
          servicios, cuando sea técnicamente posible.
        </li>
      </ul>
      <br />
      <p>
        Para ejercer estos derechos, puede comunicarse a través del correo
        <strong>gestion.datospersonales@crehana.com</strong> o mediante los
        canales dispuestos en nuestra plataforma.
      </p>
      <br />
      <Subtitle>8. CAMBIOS EN LA POLÍTICA</Subtitle>
      <p>
        Crehana se reserva el derecho de actualizar esta Política de Protección
        de Datos Personales en cualquier momento, para reflejar cambios en la
        normativa o en nuestros procesos internos. Las actualizaciones se
        publicarán en nuestro sitio web y entrarán en vigencia a partir de la
        fecha de su publicación.
      </p>
      <br />
      <Subtitle>9. VIGENCIA</Subtitle>
      <p>
        Esta política entra en vigencia a partir del{' '}
        <strong>15 de septiembre de 2025</strong> y permanecerá activa mientras
        Crehana continúe tratando datos personales.
      </p>
      <br />
      <Subtitle>10. CONTACTO</Subtitle>
      <p>
        Si tiene preguntas, solicitudes o reclamos relacionados con esta
        política o el tratamiento de sus datos personales, puede contactarnos a
        través de:
      </p>
      <ul>
        <li>
          <strong>Correo electrónico: </strong>
          gestion.datospersonales@crehana.com
        </li>
      </ul>
    </section>
  </RouteWrapper>
);

export default PersonalDataProtectionPolicyCrehanaATS;
